import { Pipe, PipeTransform } from "@angular/core";
import moment from "moment";

@Pipe({
    name: "splitTime",
})
export class SplitTimePipe implements PipeTransform {
    /* eslint-disable class-methods-use-this */
    transform(date: string | moment.Moment): string {
        if (!date) {
            return "";
        }
        let mDate: moment.Moment;
        if (typeof date === "string") {
            mDate = moment(date);
        } else {
            mDate = date;
        }
        mDate.local();
        return mDate.format("HH:mm");
    }
}
